<template>
  <div class="w-full flex flex-col justify-center items-center font-rubik bg-themeComponentBg-light px-5 lg:px-0">
    <div class="flex flex-col gap-6 justify-center items-center about-ca-container">
      <h3 v-html="heading"></h3>
      <div v-html="contentHtml" class="text-center lg:text-left"></div>
      <div class="w-full flex lg:justify-center gap-4 pt-5 lg:pt-6">
        <button
          class="about-ca-get-quote-btn flex flex-col items-center justify-center"
          data-vue-init="lead-flow"
          data-props='{ "gtag": "get_quote"}'
        >
          <p>Get Quote</p>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    heading: {
      type: String,
      default: ''
    },
    contentHtml: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.about-ca-container {
  padding-top: 112px;
  width: 100%;
  max-width: 802px;
}
.about-ca-container h3 {
  font-size: 40px;
  font-weight: 400;
  line-height: 48px;
  letter-spacing: -0.02em;
  color: #1E293B;
}
.about-ca-container p {
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: -0.02em;
  color: #1E293B;
  text-align: center;
}
.about-ca-get-quote-btn {
  width: 135px;
  height: 44px;
  background-color: #3565FC;
  border: 1px solid #90B6FF;
  border-radius: 99px;
}
.about-ca-get-quote-btn p {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.0125em;
  color: #FFF;
}
.about-ca-learn-more-btn {
  width: 135px;
  height: 44px;
  border: 1px solid #334155;
  border-radius: 99px;
}
.about-ca-learn-more-btn p {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.0125em;
  color: #334155;
}

/* Mobile */
@media (max-width: 1024px) {
  .about-ca-container {
    padding-top: 64px;
  }
  .about-ca-container p {
    text-align: start;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.0125em;
  }
}
</style>